import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
export function FailedSolutionsSection() {
  return <section className="py-24 bg-lightSage px-4" data-id="element-51">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-6" data-id="element-54">
            ¿Por Qué Nada Ha Funcionado Hasta Ahora?
          </h2>
          <div className="space-y-6 text-lg text-warmBrown" data-id="element-55">
            <p data-id="element-56">
              No es tu culpa. Las soluciones antiguas no entienden lo que está
              pasando dentro de ti. Dietas genéricas, planes restrictivos y
              suplementos al azar solo agravan los síntomas, porque no respetan
              los ritmos naturales de tu cuerpo.
            </p>
            <p data-id="element-57">
              El problema es que esas soluciones no entienden el ritmo natural
              de tu cuerpo. No se trata solo de qué comes, sino de cuándo y cómo
              lo haces. Las dietas tradicionales fuerzan tu cuerpo y elevan el
              estrés. Y el estrés empeora los síntomas. Es un ciclo que no
              termina.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-10 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-58">
          <div className="absolute top-0 right-0 w-32 h-32 bg-sage/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-59" />

          <h3 className="text-xl font-heading font-bold text-center text-forest mb-8" data-id="element-60">
            El Ciclo del Estrés Hormonal
          </h3>

          <div className="relative flex flex-col items-center space-y-4" data-id="element-61">
            <div className="flex flex-col items-center text-center p-4 bg-cream rounded-xl w-full max-w-xs border border-sage/20" data-id="element-62">
              <span className="font-bold text-warmBrown" data-id="element-63">
                Dieta Restrictiva
              </span>
            </div>

            <RefreshCw className="w-6 h-6 text-gold animate-spin-slow" data-id="element-64" />

            <div className="flex flex-col items-center text-center p-4 bg-cream rounded-xl w-full max-w-xs border border-sage/20" data-id="element-65">
              <span className="font-bold text-warmBrown" data-id="element-66">
                Más Estrés (Cortisol)
              </span>
            </div>

            <RefreshCw className="w-6 h-6 text-gold animate-spin-slow" data-id="element-67" />

            <div className="flex flex-col items-center text-center p-4 bg-cream rounded-xl w-full max-w-xs border border-sage/20" data-id="element-68">
              <span className="font-bold text-warmBrown" data-id="element-69">Peores Síntomas</span>
            </div>

            <RefreshCw className="w-6 h-6 text-gold animate-spin-slow" data-id="element-70" />

            <div className="flex flex-col items-center text-center p-4 bg-cream rounded-xl w-full max-w-xs border border-sage/20" data-id="element-71">
              <span className="font-bold text-warmBrown" data-id="element-72">Más Frustración</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}